import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollModal } from './../../../Helpers/Validation/Employees/PayrollValidation';
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import ReactLoading from "react-loading";
import * as XLSX from "xlsx";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllPayroll, deletePayroll } from './../../../Helpers/apiCalls/Employees/PayrollApi';
import { createUploadSchedule } from './../../../Helpers/apiCalls/Employees/PayrollApi';
import upload from "../../../Assets/Images/upload.png";
import { Upload} from "antd";
import { getAllBranches } from './../../../Helpers/apiCalls/Manage/Branches';
import Footer from "../../../Components/Footer/Footer";


export default function UploadSchedule() {
    const { Dragger } = Upload;
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        employee_id: "",
        employee_name: "",
        date_from: "",
        date_to: "",
        user: accountType,
    })
    const [isError, setIsError] = useState({
        employee_id: false,
        payroll_month_from: false,
        payroll_month_to: false,
    });
    // const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataCsv, setAllDataCsv] = useState([]);
    const [totalNet, setTotalNet] = useState("0");
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [file, setFile] = useState("");
    const [fileList, setFileList] = useState([]);
    const [addDetails, setAddDetails] = useState({})
    const [branches, setBranches] = useState([])

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     /* add modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const handleShowAddModal = () => setShowAddModal(true);
     const handleCloseAddModal = () => setShowAddModal(false); 

     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState({
        label: "",
        value: "",
     });
     const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
     const [selectedMonthTo, setSelectedMonthTo] = useState("");
     const today = Moment().format("MM/DD/YYYY");

     
     
     
    
    const excelHeaders = [
        { label: "Payroll Range", key: "payroll_range" },
        { label: "Disbursement Date", key: "disbursement_date" },
        { label: "Type", key: "disbursement_type" },
        { label: "Employee Name", key: "employee_name" },
        { label: "Department", key: "department_name" },
        { label: "Payee ID", key: "payee_id" },
        { label: "Net Pay", key: "grand_total" },
        { label: "Total Working Hours", key: "working_hours" },
        { label: "Rate", key: "rate" },
        { label: "Basic Pay", key: "basic_pay" },
        { label: "Total Wages", key: "total_addition" },
        { label: "Total Deductions", key: "total_deduction" },
        { label: "Transportation Allowance", key: "transportation_allowance" },
        { label: "Other Allowances", key: "other_allowances" },
        { label: "Holiday", key: "holidays" },
        { label: "Other Wages", key: "other_wages" },
        { label: "Philhealth", key: "philhealth" },
        { label: "SSS", key: "sss" },
        { label: "Pagibig", key: "pagibig" },
        { label: "Shortage", key: "shortage" },
        { label: "Cash Advance", key: "cash_advance" },
        { label: "Other Deductions", key: "other_deductions" },
        { label: "SSS Loan", key: "sss_loan" },
        { label: "Pagibig Loan", key: "pagibig_loan" },
        { label: "Remarks", key: "remarks" },
    ];

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleAddModal(e) {
        if(validatePayrollModal(selectedEmployee, selectedMonthFrom, selectedMonthTo, setIsError)) {
            navigate(
                `/payroll/add/${selectedEmployee.value}`, {
                    state: { selectedEmployee: selectedEmployee, date_from: selectedMonthFrom, date_to: selectedMonthTo  },
                }
            )
        }
    }

    
    const handleAddChange = (e, select) => {
        if(select) {
            const { label, value } = e;
            setAddDetails((prevState) => ({
                ...prevState,
                ["branch_id"]: value,
                ["branch_id_value"]: {
                    label: label,
                    value: value,
                },
            }));
        } else {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    }
    

    // async function fetchEmployees() {

    //     const response = await getAllEmployees();
    //     if (response.error) {
    //         setEmployees([])
    //     } else {
    //         let result = response.data.data.map((data) => {
    //             var employee = data;
    //             employee.label = data.first_name + " " + data.last_name;
    //             employee.value = data.id;
    //             return employee;
    //         });
    //         setEmployees(result);
    //     }
    // }

    async function fetchBranches() {
        setShowLoader(true);
        setBranches([])
        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => {
                return data.is_franchise === "0"
            })
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            setBranches([{label: "All Branches", value:""}, ...allBranches]);
        }
        setShowLoader(false);
    }

    const handleBeforeUpload = (file) => {
        setFile([...fileList, file]);
        return false;
      };
    
    const handleChangeFiles = ({ fileList, file }) => {
        // 
        // 
        setFile([...fileList]);
    };
    const handleRemove = (selectedFile) => {
        // 

        var newlist = file.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFile(newlist);
    };

    
    const handleConvert = () =>{
        //convert file into an array of unsigned integers
        //file => variable that contains the file chosen
        
        file[0].arrayBuffer().then((res)=>{
    
            //get the filename without the extension
            let filename = file[0].name.substring(0, file[0].name.indexOf("."))
    
            //read data
            let data = new Uint8Array(res)
    
            //for creating the actual workbook from the data
            var workbook = XLSX.read(data, {type:"array", cellDates: true});
    
            //read the first sheet name in the excel file
            var sheetName = workbook.SheetNames[0];
    
            //locate the data inside the sheet name
            let worksheet = workbook.Sheets[sheetName]
    
            //convert sheet data to json data inside the certain sheet
            let jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1, defval: ''})
            let newdata = jsonData.filter((data, key)=>jsonData[key][1] !== "" && jsonData[key][0] !== "" && key !== 0 && key !== 1 && key !== 2 && key !== 3 && key !== 4)
            
             
            if(newdata.length === 0) {
                toast.error("Please upload and follow the correct excel format", {
                    style: toastStyle(),
                });
            } else {
                handleUploadSchedule(newdata)
            }
    
            //convert json data to sheet
            let newWorksheet = XLSX.utils.json_to_sheet(jsonData)
    
            //initialize new workbook
            let newWorkbook = XLSX.utils.book_new();
    
            //append worksheet to the new workbook 
            XLSX.utils.book_append_sheet(newWorkbook, newWorksheet)
    
            //create new csv file from workbook
            // XLSX.writeFile(newWorkbook, filename + "fromcode.csv")
        })
        
    }

    async function handleUploadSchedule(data) {
        setIsClicked(true)
        const response = await createUploadSchedule(addDetails, data);
        
        if (response.data) {
            toast.success("Successfully uploaded schedule!", {
                style: toastStyle(),
            });
            setTimeout(() => {
                navigate("/scheduler")
            }, 1000);
        } else {
            toast.error("Something went wrong", {
                style: toastStyle(),
            });
            // toast.error(response.error.response?.data.messages.error, {
            //     style: toastStyle(),
            // });
            setTimeout(() => {
                setTimeout(() => {
                    // navigate("/scheduler")
                    setIsClicked(false)
                }, 1000);
            }, 1000);
        }
    }

    React.useEffect(() => {
        fetchBranches();
    }, []);

    React.useEffect(() => {
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={6}>
                        <h1 className="page-title"> Upload Schedule </h1>
                    </Col>
                </Row>
                <div className="print-container px-3 py-2 ">
                    <Row className="mt-4 pt-3">
                        <Col xs={6}>
                            <span className="PI-modal-label ">BRANCH</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Branch..."
                                value={addDetails.branch_id_value}
                                options={branches}
                                onChange={(e) => handleAddChange(e, "select")}
                            />
                        </Col>
                        <Col xs={3}>
                            <span className="PI-modal-label ">DATE FROM</span>
                            <Form.Control
                                 type="date"
                                 name="date_from"
                                 className="nc-modal-custom-text"
                                 onChange={(e) => { handleAddChange(e) }}
                             />
                             <InputError
                                 isValid={isError.date_from}
                                 message={"Month from is required"}
                             />
                        </Col>
                        <Col xs={3}>
                             <span className="PI-modal-label ">DATE TO</span>
                            <Form.Control
                                 type="date"
                                 name="date_to"
                                 className="nc-modal-custom-text"
                                 onChange={(e) => { handleAddChange(e) }}
                             />
                             <InputError
                                 isValid={isError.date_to}
                                 message={"Month to is required"}
                             />
                        </Col>
                    </Row>
                    <Row className="mt-4 pt-3">
                        <Col xs={12} className="mt-2">
                            <Dragger
                                {...{
                                // style: { width: 550 },
                                file,
                                defaultFileList: file,
                                onRemove: handleRemove,
                                beforeUpload: handleBeforeUpload,
                                multiple: false,
                                // onChange: handleOnChange,
                                listType: "picture",
                                progress: { showInfo: true },
                                data: (file) => { 
                                    // 
                                }
                                }}
                            >
                                <img
                                    src={upload}
                                    alt="upload"
                                    className="cursor-pointer"
                                />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                                {/* <p className="ant-upload-hint">
                                    Support for a single or bulk upload.
                                </p>  */}
                            </Dragger>
                        </Col>
                    </Row>
                    <Row className="mt-4 pt-3">
                        {/* <input class="form-control date-filter gotham" type="file" id="formFileSm" onChange={(e)=>setFile(e.target.files[0])}/> */}
                    </Row>
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        {isClicked === true && (
                            <div className="button-primary d-flex justify-content-center me-3">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        )}
                        {isClicked === false && (
                            <button
                                type="button"
                                className="button-primary me-3"
                                onClick={() => handleConvert()}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD SCHEDULER
                    </span>
                    <div className="PI-modal-body mt-3">
                        <span className="PI-modal-label">EMPLOYEE NAME</span>
                        <Select
                            className="react-select-container mb-4"
                            classNamePrefix="react-select"
                            placeholder="Select Employee..."
                            value={selectedEmployee}
                            options={employees}
                            onChange={(e) => setSelectedEmployee({
                                label: e.label,
                                value: e.value
                            })}
                        />
                        <InputError
                            isValid={isError.employee_id}
                            message={"Employee is required"}
                        />
                       <span className="PI-modal-label ">DATE FROM</span>
                       <Form.Control
                            type="date"
                            name="payroll_month_from"
                            className="nc-modal-custom-text"
                            onChange={(e) => { setSelectedMonthFrom(e.target.value) }}
                        />
                        <InputError
                            isValid={isError.payroll_month_from}
                            message={"Month from is required"}
                        />
                        <span className="PI-modal-label ">DATE TO</span>
                       <Form.Control
                            type="date"
                            name="payroll_month_to"
                            className="nc-modal-custom-text"
                            onChange={(e) => { setSelectedMonthTo(e.target.value) }}
                        />
                        <InputError
                            isValid={isError.payroll_month_to}
                            message={"Month to is required"}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="PI-modal-buttons">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={handleAddModal}
                        className="button-primary"
                    >
                        Continue
                    </button>
                </Modal.Footer>
            </Modal>
            <Footer/>
        </div>
    );
}
